import { render } from "./more-dialog.vue?vue&type=template&id=b30c3320&scoped=true&ts=true"
import script from "./more-dialog.vue?vue&type=script&lang=ts"
export * from "./more-dialog.vue?vue&type=script&lang=ts"

import "./more-dialog.vue?vue&type=style&index=0&id=b30c3320&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b30c3320"]])

export default __exports__